import { SelectBoxItem, LabelStrings } from './types';
export const clickItemHandler = (item: SelectBoxItem, selectedItems: SelectBoxItem[]) => {
  return selectedItems.some((propItem) => propItem.value === item.value)
    ? selectedItems.filter((propItem) => propItem.value !== item.value)
    : selectedItems.concat(item);
};

export const clickSearchItemHandler = (item: SelectBoxItem, searchItems: SelectBoxItem[]) => {
  return searchItems.some((propItem) => propItem.value === item.value)
    ? searchItems.filter((propItem) => propItem.value !== item.value)
    : searchItems.concat(item);
};

export const selectedItemsLabelHandler = (
  isSelectedAll: boolean,
  selectedItems: SelectBoxItem[],
  labelStrings: LabelStrings,
  showCountChip?: boolean
) => {
  switch (true) {
    case selectedItems.length && showCountChip:
      return `${labelStrings.itemType}`;
    case isSelectedAll:
      return labelStrings.allSelectedLabel;
    case selectedItems.length > 1:
      return `${selectedItems.length} ${labelStrings.itemType}`;
    case selectedItems.length === 1:
      return selectedItems[0].text;
    default:
      return labelStrings.noneLabel;
  }
};
